import {
  Container,
  Description,
  Header,
  IconButton,
  Title
} from './MouseOver.styles'
import Icon from '../Icon'
import { MouseOverCardProps } from './MouseOver.types'

const MouseOverCard = ({
  title,
  description,
  type = 'default',
  heightClass = 'regular',
  onClose
}: MouseOverCardProps) => {
  return (
    <Container type={type} heightClass={heightClass}>
      <Header>
        <Title heightClass={heightClass}>{title}</Title>
        <IconButton onClick={onClose}>
          <Icon iconName='Close' icColor='blackText' icSize='semiSmall' />
        </IconButton>
      </Header>
      <Description heightClass={heightClass}>{description}</Description>
    </Container>
  )
}

export default MouseOverCard
